import moment from "moment";
import {
  Box,
  List,
  ListSubheader,
  ListItem,
  ListItemText,
} from "@mui/material";
import groupBy from "../../common/groupBy";
import MEALS from "./MEALS.json";

const styles = {
  dayBox: {
    position: "relative",
  },
  dayBoxLabel: {
    position: "absolute",
    left: 0,
    top: 0,
  },
  planSource: {
    padding: "6px 0",
    opacity: 0.5,
    fontSize: "0.8rem",
    textAlign: "center",
  },
};

const DayItems = ({ date, data }) => {
  const plan = groupBy(data, (item) => {
    return `${item.meal}-${moment(item.date).format("HH")}`;
  });

  return Object.keys(plan).map((mealAndHour) => {
    const meal = mealAndHour.replace(/-\d+$/, "");

    return (
      <List
        key={`day-meals-${mealAndHour}`}
        subheader={
          <ListSubheader>
            {MEALS[meal]} - {date.format("ddd, DD.MMMM YYYY")}
          </ListSubheader>
        }
      >
        {plan[mealAndHour].map((item) => {
          let amountAndUnit = null;
          if (item.amount) {
            amountAndUnit = item.amount;
            if (item.unit) {
              amountAndUnit += ` ${item.unit.sign}`;
            }
          }

          return (
            <ListItem key={`day-meal-${mealAndHour}-${item.dish.id}`}>
              <ListItemText
                primary={item.dish.name}
                secondary={amountAndUnit}
              />
            </ListItem>
          );
        })}
      </List>
    );
  });
};

const Mobile = ({ data, start, planId }) => {
  const plan = groupBy(data, (item) => moment(item.date).format("YYYY-MM-DD"));

  return (
    <>
      <Box sx={styles.planSource}>Plan #{planId}</Box>
      {Object.keys(plan).map((date, i) => {
        const date2 = start.clone().add(i, "days");

        return (
          <Box key={`day-${date}`} sx={styles.dayBox}>
            <Box sx={styles.dayBoxLabel}>
              {date2.format("ddd, DD.MMM YYYY")}
            </Box>
            <DayItems date={date2} data={plan[date]} />
          </Box>
        );
      })}
    </>
  );
};

export default Mobile;
